import Action from './Action'
import { api } from '../../plugins/axios'

export default class SetTokenAction extends Action {
  handle () {
    api.defaults.headers.common.Authorization = `Bearer ${this.data.token}`
  }
}
